import React from 'react';

import { Link } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import { useActivitiesPredecessorsStore } from 'store/activitiesPredecessors.store';

import Slider from 'components/common/Slider/Slider';

import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';
import { Select } from 'components/DesignSystem/Select';
import { InputOption } from 'components/DesignSystem/Select/components/InputOption/InputOption';
import { ValueContainer } from 'components/DesignSystem/Select/components/ValueContainer/ValueContainer';
import { Switch } from 'components/DesignSystem/Switch';
import {
    IActivityTypeOptions,
    activityTypeOptions,
    projectActivitiesCompletionPlanSegmentFilter,
    statusOptions,
} from 'components/widgets/ActivityCompletionPlan/ActivitiesPredecessors.utils';
import classes from 'components/widgets/ActivityCompletionPlan/components/SortFilterPanel/SortFilterPanel.module.scss';

interface Props {
    taskVersionHashCode: string | undefined;
    hashcode: string | undefined;
}

export const SortFilterPanel = ({ taskVersionHashCode, hashcode }: Props) => {
    const {
        activityTypeFilter,
        statusFilter,
        submittedCompletionFilter,
        activeTab: completionPlanSegment,
        isCriticalPath,
        isDelayDriver,
        update,
    } = useActivitiesPredecessorsStore();

    const linkToBattlecards = () => {
        const riskIndicatorsIsCriticalPath = isCriticalPath ? 'CRITICAL_PATH_USER_CARD_BOARD' : null;
        const riskIndicatorsIsDelayedDriver = isDelayDriver ? 'DELAY_DRIVER_CARD_BOARD' : null;
        const riskIndicators = [riskIndicatorsIsCriticalPath, riskIndicatorsIsDelayedDriver].filter(Boolean);

        const query = {
            cardActivity: activityTypeFilter.map((item) => item.queryStringValue),
            status: statusFilter.map((item) => item.value),
            submittedCompletion: submittedCompletionFilter,
            riskIndicators: riskIndicators.length === 0 ? null : riskIndicators,
            milestoneFragnet: taskVersionHashCode,
            completionPlanSegment: projectActivitiesCompletionPlanSegmentFilter[completionPlanSegment],
        };

        return AppRoutes.buildPathWithQuery(
            [AppRoutes.DASHBOARD_EXECUTION_PATH, executionConfig.battlecards.link, hashcode],
            query,
            { encode: false },
        );
    };

    return (
        <div className={classes.sortFilterContainer}>
            <div data-testid={'filter-container'} className={classes.filterContainer}>
                <div className={classes.selectWrapper}>
                    <div className={classes.title}>Activity Type</div>
                    <Select<IActivityTypeOptions, true>
                        value={activityTypeFilter}
                        options={activityTypeOptions}
                        onChange={(value) => update({ activityTypeFilter: value })}
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        isMulti={true}
                        placeholder={'Select Activity Type...'}
                        components={{
                            Option: InputOption,
                            ValueContainer: ValueContainer,
                        }}
                    />
                </div>
                <div className={classes.selectWrapper}>
                    <div className={classes.title}>Status</div>
                    <Select<ISelectOption<string>, true>
                        value={statusFilter}
                        options={statusOptions}
                        onChange={(value) => update({ statusFilter: value })}
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        isMulti={true}
                        placeholder={'Select Status...'}
                        components={{
                            Option: InputOption,
                            ValueContainer: ValueContainer,
                        }}
                    />
                </div>
                <div>
                    <Switch
                        onChange={(event) => update({ isDelayDriver: event.target.checked })}
                        checked={isDelayDriver}
                        label={'Delay Driver'}
                        labelPlacement={'start'}
                    />
                </div>
                <div>
                    <Switch
                        onChange={(event) => update({ isCriticalPath: event.target.checked })}
                        checked={isCriticalPath}
                        label={'Critical Path Only'}
                        labelPlacement={'start'}
                    />
                </div>

                <div className={classes.submittedCompletion}>
                    <div className={classes.sliderTitle}>Submitted Completion</div>
                    <div className={classes.sliderWrapper}>
                        <Slider
                            id={'completion-plan-submittedCompletion-slider'}
                            defaultValue={submittedCompletionFilter}
                            step={10}
                            min={0}
                            max={100}
                            valueLabelDisplay={'on'}
                            onChangeCommitted={(e, value) => update({ submittedCompletionFilter: value })}
                        />
                    </div>
                </div>
            </div>
            <div className={classes.linkContainer}>
                <Link to={linkToBattlecards()}>View in {executionConfig.battlecards.title}</Link>
            </div>
        </div>
    );
};
